import {
  MC_RAW_DATA_LIST_FAILED,
  MC_RAW_DATA_LIST_REQUEST,
  MC_RAW_DATA_LIST_SUCCESS,
} from "app/redux/actions/Factory/Dressing/MCRawDataListing/constants";

const INIT_STATE = {
  loading: false,
  totalPage: 0,
  data: [],
  error: {
    isError: false,
    message: null,
  },
};

export const DressingMCRawDataReducer = function (state = INIT_STATE, action) {
  switch (action?.type) {
    case MC_RAW_DATA_LIST_REQUEST:
      return {
        loading: true,
        totalPage: 0,
        data: [],
        error: {
          isError: false,
          message: null,
        },
      };
    case MC_RAW_DATA_LIST_SUCCESS:
      return {
        loading: false,
        data: action?.payload?.data,
        totalPage: action?.payload?.totalPage,
        error: {
          isError: false,
          message: null,
        },
      };
    case MC_RAW_DATA_LIST_FAILED:
      const { isError = true, message = "Something Went Wrong" } =
        action?.payload?.error || {};
      return {
        loading: false,
        totalPage: 0,
        data: [],
        error: {
          isError: isError,
          message: message,
        },
      };
    default:
      return state;
  }
};
